module.exports = __webpack_public_path__ + "img/Lost_Island_Map.d7bea074.webp";